<template>
  <div class="con">
    <vue-tinymce
      id="myEdit"
      v-model="content"
      :setting="setting"
      @change="iseditchang"
    />
  </div>
</template>
<script>
import "./tinymce.min.js";
import "./themes/silver/theme.min.js";
import "./langs/zh_CN.js";
import env from "../../env";
export default {
  props: {
    isactivitiesCon: String,
  },
  data() {
    return {
      content: "",
      setting: {
        menubar: false,
        toolbar:
          "undo redo | fullscreen | formatselect alignleft aligncenter alignright alignjustify | link unlink | numlist bullist | image media table | fontselect fontsizeselect forecolor backcolor | bold italic underline strikethrough | indent outdent | superscript subscript | removeformat |",
        toolbar_drawer: "sliding",
        quickbars_selection_toolbar:
          "removeformat | bold italic underline strikethrough | fontsizeselect forecolor backcolor",
        plugins: "link image media table lists fullscreen quickbars",
        language: "zh_CN", //本地化设置
        height: 400,
        images_upload_handler: function (blobInfo, success, failure, progress) {
          var xhr, formData;
          xhr = new XMLHttpRequest();
          xhr.withCredentials = false;
          xhr.open("POST", env.basUrl + "api/obs-upload-set");
          xhr.upload.onprogress = function (e) {
            progress((e.loaded / e.total) * 100);
          };
          xhr.onload = function () {
            var json;
            if (xhr.status == 403) {
              failure("HTTP Error: " + xhr.status, { remove: true });
              return;
            }
            if (xhr.status < 200 || xhr.status >= 300) {
              failure("HTTP Error: " + xhr.status);
              return;
            }
            json = JSON.parse(xhr.responseText);
            success(json.file_path);
          };
          xhr.onerror = function () {
            failure(
              "Image upload failed due to a XHR Transport error. Code: " +
                xhr.status
            );
          };
          formData = new FormData();
          formData.append("file", blobInfo.blob(), blobInfo.filename());
          xhr.setRequestHeader(
            "Authorization",
            `Bearer ${window.localStorage.getItem("token")}`
          );
          xhr.send(formData);
        },
      },
    };
  },
  created() {},
  mounted() {
    tinymce.init({
      selector: "#myEdit",
      language: "zh_CN",
    });
    if (this.isactivitiesCon) {
      this.content = this.isactivitiesCon;
    }
  },
  methods: {
    iseditchang() {
      this.$emit("emitedit", this.content);
    },
  },
};
</script>
<style scoped>
@import url("./skins/ui/oxide/skin.min.css");
</style>